import React, { useState } from "react";
import axios from "axios";
import { Collections, Song } from "../types/type";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";
import { mapDocToData } from "../api/fetch.api";

const TestPage2: React.FC = () => {
  const [url, setUrl] = useState<string>("");
  const [videoInfo, setVideoInfo] = useState<any>(null);
  const [selectedFormat, setSelectedFormat] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  // 유튜브 비디오 정보 가져오기
  const fetchVideoInfo = async () => {
    setIsLoading(true);
    setErrorMessage("");

    try {
      const response = await axios.post("http://localhost:8080/video-info", {
        url,
      });
      setVideoInfo(response.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setErrorMessage("Failed to fetch video information");
      console.error("Error fetching video info:", error);
    }
  };

  // 유튜브 비디오 다운로드
  const handleDownload = () => {
    if (!selectedFormat) {
      alert("Please select a format");
      return;
    }

    const downloadUrl = `http://localhost:8080/download?url=${encodeURIComponent(
      url
    )}&format=${selectedFormat}`;

    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", "video.mp4");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const 직접 = async () => {
    try {
      const snapshot = await getDocs(collection(db, Collections.SONG));
      const totalSongList = snapshot.docs.map((doc) => mapDocToData<Song>(doc));

      // totalSongList.map((song)=>{
      //   const updatedSong = {
      //     ...song,
      //     artwork : song.artwork.
      //   }
      // })

      return totalSongList;
    } catch (error) {
      console.error(error);
    }
  };

  const 클릭 = async () => {
    const result = await 직접();
    console.log("result : ", result);
  };

  return (
    <div className="App" style={{ padding: "20px" }}>
      <button onClick={클릭}>백업</button>
      <h1>YouTube Downloader</h1>
      <input
        type="text"
        placeholder="Enter YouTube URL"
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        style={{ width: "300px", padding: "5px", marginBottom: "10px" }}
      />
      <button onClick={fetchVideoInfo} disabled={isLoading}>
        {isLoading ? "Fetching..." : "Fetch Video Info"}
      </button>

      {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}

      {videoInfo && (
        <div style={{ marginTop: "20px" }}>
          <h2>{videoInfo.title}</h2>
          <img
            src={videoInfo.thumbnail}
            alt="thumbnail"
            style={{ width: "300px" }}
          />

          <div style={{ marginTop: "20px" }}>
            <h3>Select Format</h3>
            <select
              value={selectedFormat}
              onChange={(e) => setSelectedFormat(e.target.value)}
              style={{ padding: "5px" }}
            >
              <option value="">--Select a format--</option>
              {videoInfo.formats.map((format: any, index: number) => (
                <option key={index} value={format.itag}>
                  {format.qualityLabel} - {format.container} ({format.codecs})
                </option>
              ))}
            </select>
          </div>

          <button onClick={handleDownload} style={{ marginTop: "20px" }}>
            Download
          </button>
        </div>
      )}
    </div>
  );
};

export default TestPage2;
